(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/map-play.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/map-play.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useRef = _React.useRef,
  useState = _React.useState;
const CONSTANTS = svs.lyckoplatsen.components.shared_constants.CONSTANTS;
const getPlayMapHandler = svs.lyckoplatsen.components.shared_map.getPlayMapHandler;
const _svs$lyckoplatsen$sha = svs.lyckoplatsen.shared_charity.jotai.atoms,
  charityAtom = _svs$lyckoplatsen$sha.charityAtom,
  activeCharitiesAtom = _svs$lyckoplatsen$sha.activeCharitiesAtom;
const _svs$lyckoplatsen$sha2 = svs.lyckoplatsen.shared_map.atoms,
  isMovingAtom = _svs$lyckoplatsen$sha2.isMovingAtom,
  isCenteredAtom = _svs$lyckoplatsen$sha2.isCenteredAtom,
  mapZoomLevelAtom = _svs$lyckoplatsen$sha2.mapZoomLevelAtom,
  mapFlyToLevelAtom = _svs$lyckoplatsen$sha2.mapFlyToLevelAtom;
const filterCharityById = svs.lyckoplatsen.page_play.utils.filterCharityById;
const showWrongCharityDialog = svs.lyckoplatsen.components.shared_charity.utils.showWrongCharityDialog;
const logger = svs.lyckoplatsen.logger;
const _jotai = jotai,
  useSetAtom = _jotai.useSetAtom,
  useAtom = _jotai.useAtom,
  useAtomValue = _jotai.useAtomValue;
const useIsUserAfk = svs.lyckoplatsen.components.page_play.react.hooks.useIsUserAfk;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.jotai.atoms,
  pinLocationAtom = _svs$lyckoplatsen$com.pinLocationAtom,
  pinLocationTypeAtom = _svs$lyckoplatsen$com.pinLocationTypeAtom,
  disableCenterMapButtonAtom = _svs$lyckoplatsen$com.disableCenterMapButtonAtom,
  mapLocationAtom = _svs$lyckoplatsen$com.mapLocationAtom,
  locationConfirmedAtom = _svs$lyckoplatsen$com.locationConfirmedAtom,
  shouldShowPinAtom = _svs$lyckoplatsen$com.shouldShowPinAtom,
  randomLocationTriggerAtom = _svs$lyckoplatsen$com.randomLocationTriggerAtom,
  isRandomizingLocationAtom = _svs$lyckoplatsen$com.isRandomizingLocationAtom;
const mapErrorDialog = svs.lyckoplatsen.shared_map.utils.mapErrorDialog;
const nodeId = 'mapPlay';
const MapPlay = () => {
  const mapHandlerPlay = useMemo(() => getPlayMapHandler(), []);
  const _useAtom = useAtom(pinLocationAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    pinLocation = _useAtom2[0],
    setPinLocation = _useAtom2[1];
  const mapLocation = useAtomValue(mapLocationAtom);
  const _useAtom3 = useAtom(isCenteredAtom),
    _useAtom4 = _slicedToArray(_useAtom3, 2),
    isCentered = _useAtom4[0],
    setIsCentered = _useAtom4[1];
  const setShouldShowPin = useSetAtom(shouldShowPinAtom);
  const _useAtom5 = useAtom(pinLocationTypeAtom),
    _useAtom6 = _slicedToArray(_useAtom5, 2),
    pinLocationType = _useAtom6[0],
    setPinLocationType = _useAtom6[1];
  const locationConfirmed = useAtomValue(locationConfirmedAtom);
  const setDisableCenterMapButton = useSetAtom(disableCenterMapButtonAtom);
  const _useAtom7 = useAtom(mapZoomLevelAtom),
    _useAtom8 = _slicedToArray(_useAtom7, 2),
    mapZoomLevel = _useAtom8[0],
    setMapZoomLevel = _useAtom8[1];
  const _useAtom9 = useAtom(mapFlyToLevelAtom),
    _useAtom0 = _slicedToArray(_useAtom9, 2),
    mapFlyToLevel = _useAtom0[0],
    setMapFlyToLevel = _useAtom0[1];
  const setIsMoving = useSetAtom(isMovingAtom);
  const charity = useAtomValue(charityAtom);
  const setCharity = useSetAtom(charityAtom);
  const activeCharities = useAtomValue(activeCharitiesAtom);
  const randomLocationTrigger = useAtomValue(randomLocationTriggerAtom);
  const setIsRandomizingLocation = useSetAtom(isRandomizingLocationAtom);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    charityChecked = _useState2[0],
    setCharityChecked = _useState2[1];
  const isFirstPinPlacement = useRef(true);
  const trackPinPlacedByClick = () => {
    svs.components.analytics.trackEvent({
      category: 'Lyckoplatsen',
      action: 'Sök manuellt',
      opt_label: CONSTANTS.LOCATION_TYPES.OTHER
    });
  };
  useEffect(() => {
    var _svs$utils$paramHandl;
    const paramCharityId = (_svs$utils$paramHandl = svs.utils.paramHandler.get({
      key: 'charityId'
    })) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value;
    if (paramCharityId) {
      const charity = filterCharityById(activeCharities, parseInt(paramCharityId, 10));
      if (charity) {
        setCharity(charity);
      } else {
        setCharity(false);
        showWrongCharityDialog();
        logger.info("Wrong Param, CharityId dont exists, charityId: ".concat(paramCharityId));
      }
      svs.utils.paramHandler.remove({
        key: 'charityId'
      });
    }
    setCharityChecked(true);
  }, []);

  useEffect(() => {
    const mapOptions = {
      nodeId,
      maxZoom: 18,
      maxBounds: [[72.1, -5.5], [47.1, 39.5]],
      location: pinLocation,
      showErrorOverlay: false,
      zoomSnap: 0.25,
      zoomLevel: mapZoomLevel,
      wheelPxPerZoomLevel: 25,
      touchZoom: true,
      errorCallback: mapErrorDialog,
      zoomAnimation: true,
      fadeAnimation: true,
      zoomControl: false,
      type: 'play',
      geoJson: true,
      charity: Boolean(charity === null || charity === void 0 ? void 0 : charity.charityId)
    };
    const eventHandlers = {
      mapClicked: function () {
        let pinLocation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
          lat: null,
          lng: null
        };
        setPinLocationType(CONSTANTS.LOCATION_TYPES.OTHER);
        setMapFlyToLevel(false);
        setPinLocation(pinLocation);
        trackPinPlacedByClick();
      },
      disableCenterMapButton: bool => {
        setDisableCenterMapButton(bool);
      },
      showPin: bool => {
        setShouldShowPin(bool);
      },
      updateIsMoving: isMoving => {
        setIsMoving(isMoving);
      },
      updateZoomLevel: zoomLevel => {
        setMapZoomLevel(zoomLevel);
      },
      showMapErrorDialog: () => {
        mapErrorDialog();
      }
    };
    if (charityChecked) {
      mapHandlerPlay.createMap(mapOptions, eventHandlers);
    }
    return () => mapHandlerPlay.removeMap();
  }, [charityChecked]);

  useIsUserAfk();

  useEffect(() => {
    if (pinLocation.lat && charityChecked) {
      if (isFirstPinPlacement.current) {
        isFirstPinPlacement.current = false;
      }
      mapHandlerPlay.removePin({
        keepShouldShowPin: true
      });
      mapHandlerPlay.addLocationName(pinLocation, charity, pinLocationType);
      mapHandlerPlay.placePin({
        location: pinLocation,
        zoomLevel: mapFlyToLevel || mapHandlerPlay.getZoomLevel(),
        animateFlyTo: true
      });
      if (mapFlyToLevel) {
        setMapFlyToLevel(false);
      }
      mapHandlerPlay.focusMap();
    }
  }, [pinLocation, charityChecked]);

  useEffect(() => {
    if (!locationConfirmed && !pinLocation.lat) {
      mapHandlerPlay.removePin();
    } else if (locationConfirmed) {
      const location = mapFlyToLevel ? _objectSpread(_objectSpread({}, pinLocation), {}, {
        zoomLevel: mapFlyToLevel
      }) : pinLocation;
      mapHandlerPlay.moveTo(location);
    }
  }, [locationConfirmed, pinLocation]);

  useEffect(() => {
    if (mapLocation.lat && mapLocation.lng) {
      setShouldShowPin(false);
      mapHandlerPlay.removePin();
      setPinLocation({
        lat: null,
        lng: null
      });
      mapHandlerPlay.moveTo(mapLocation);
    }
  }, [mapLocation]);

  useEffect(() => {
    if (!isCentered) {
      mapHandlerPlay === null || mapHandlerPlay === void 0 || mapHandlerPlay.centerMap();
      setIsCentered(true);
    }
  }, [isCentered]);

  useEffect(() => {
    if (!randomLocationTrigger || !charityChecked) {
      return;
    }
    setShouldShowPin(false);
    setPinLocation({
      lat: null,
      lng: null
    });
    mapHandlerPlay.mapDisable();
    setIsMoving(true); 

    let cancelled = false;
    let stopSequence = () => {};
    mapHandlerPlay.centerMapIfZoomedOut(() => {
      if (cancelled) {
        return;
      }
      const locations = Array.from({
        length: 4
      }, () => mapHandlerPlay.getRandomLocationInViewport());
      if (locations.some(location => !location)) {
        setIsMoving(false);
        mapHandlerPlay.mapEnabled();
        mapHandlerPlay.placeErrorCircleAtCenter();
        return;
      }
      setIsRandomizingLocation(true);
      stopSequence = mapHandlerPlay.playRandomPinSequence(locations, location => {
        setIsRandomizingLocation(false);
        setIsMoving(false);
        setPinLocationType(CONSTANTS.LOCATION_TYPES.OTHER);
        setMapFlyToLevel(false);
        setPinLocation(location);
      });
    });
    return () => {
      cancelled = true;
      setIsRandomizingLocation(false);
      setIsMoving(false);
      mapHandlerPlay.mapEnabled();
      stopSequence();
    };
  }, [randomLocationTrigger]);
  return React.createElement("div", {
    className: "animated-body"
  }, React.createElement("div", {
    id: nodeId,
    className: "lp-map-play",
    tabIndex: "0"
  }));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  MapPlay
});

 })(window);